import { Tooltip, Button, Space, Typography } from 'antd';
import type { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';

import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useLogout } from '../hooks/useLogout';
import styles from './AccountTooltip.module.scss';

const { Text } = Typography;

interface AccountTooltipProps {
  disabled?: boolean;
}

export function AccountTooltip({ children, disabled }: PropsWithChildren<AccountTooltipProps>) {
  const { logout } = useLogout();
  const navigate = useNavigate();

  const tooltipContent = disabled ? null : (
    <div className={styles.tooltipContent}>
      <Space
        direction="vertical"
        size={0}
        className={styles.tooltipActions}
      >
        <Button
          type="text"
          icon={<UserOutlined />}
          onClick={() => navigate('/')}
          className={styles.tooltipButton}
          block
        >
          <Text className={styles.buttonText}>Profile</Text>
        </Button>

        <div className={styles.divider} />

        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={logout}
          className={`${styles.tooltipButton} ${styles.logoutButton}`}
          block
        >
          <Text className={`${styles.buttonText} ${styles.logoutText}`}>Sign Out</Text>
        </Button>
      </Space>
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="right"
      overlayClassName={styles.tooltipOverlay}
      overlayStyle={{
        maxWidth: '200px',
      }}
      trigger="hover"
      mouseEnterDelay={0.3}
      mouseLeaveDelay={0.1}
    >
      {children}
    </Tooltip>
  );
}
